const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

/**
 * Guards a missing date — `new Date(null)` is the epoch (not NaN), which rendered as "December 31, 1969".
 * @param date
 */
const formatDate = (date) => {
  if (!date) return 'N/A';
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? 'N/A' : dateFormatter.format(parsed);
};

const findDate = (flag, date, membershipInfo) =>
  membershipInfo.flags.filter((e) => e.display_name === flag)[0][date];

const flagsName = {
  has_box_subscription: 'has_box_subscription',
  canceled: 'canceled',
  canceled_box_subscription: 'canceled_box_subscription',
  canceled_refill_subscription: 'canceled_refill_subscription',
  has_refill_subscription: 'has_refill_subscription',
  expired_box_subscription: 'expired_box_subscription',
  trial: 'trial',
};

const labels = {
  expired: ['Membership Expired: ', 'Member Since: '],
  canceled: ['Membership Expires: ', 'Member Since: '],
  refill: ['Member Since: '],
};

export const getProfileDates = (membershipInfo) => {
  try {
    let datesInfo = [];
    if (membershipInfo?.flags && membershipInfo?.flags.length === 0) return datesInfo;

    if (membershipInfo?.membership_state === 'expired') {
      const expiredFlag = membershipInfo?.flags?.find(
        (e) => e.display_name === flagsName.expired_box_subscription,
      );
      if (expiredFlag) {
        datesInfo = [
          {
            label: labels.expired[0],
            date: formatDate(expiredFlag.effective_from),
          },
          {
            label: labels.expired[1],
          },
        ];
      } else
        datesInfo = [
          {
            label: labels.expired[0],
            date: formatDate(findDate(flagsName.trial, 'effective_to', membershipInfo)),
          },
          {
            label: labels.expired[1],
          },
        ];
    }

    if (membershipInfo?.membership_state === 'canceled') {
      const hasFlag = (name) => membershipInfo?.flags?.some((e) => e.display_name === name);
      // Expiry is the box's `canceled_box_subscription.effective_to`; the refill flag's is null.
      const isRefillOnly =
        hasFlag(flagsName.has_refill_subscription) && !hasFlag(flagsName.has_box_subscription);
      datesInfo = [
        {
          label: labels.canceled[0],
          date: formatDate(
            findDate(
              isRefillOnly
                ? flagsName.canceled_refill_subscription
                : flagsName.canceled_box_subscription,
              'effective_to',
              membershipInfo,
            ),
          ),
        },
        {
          label: labels.canceled[1],
        },
      ];
    }

    if (membershipInfo?.isRefillSubscription) {
      datesInfo = [
        {
          label: labels.refill[0],
        },
      ];
    }

    return datesInfo;
  } catch (_) {
    return [
      {
        label: labels.refill[0],
      },
    ];
  }
};
